var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBranch = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 4.5,
  cy: 3.5,
  r: 1.75,
  fill: "white",
  stroke: "currentColor",
  strokeWidth: 1.5
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.5,
  cy: 3.5,
  r: 1.75,
  fill: "white",
  stroke: "currentColor",
  strokeWidth: 1.5
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 4.5,
  cy: 12.5,
  r: 1.75,
  fill: "white",
  stroke: "currentColor",
  strokeWidth: 1.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.25 5H3.75V11H5.25V9H9.25C10.9069 9 12.25 7.65685 12.25 6V5H10.75V6C10.75 6.82842 10.0784 7.5 9.25 7.5H5.25V5Z",
  fill: "currentcolor"
})));
export default SvgBranch;